import { urlWithParams } from '@marketplace-web/browser/url-util'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const CREATE_BUNDLE_URL = (id: string | number): string => `/member/${id}/bundles/new`
export const BUNDLES_POLICY_URL = '/help/260'
export const BUNLDE_DISCOUNTS_POLICY_URL = '/help/257'
